import { CSSProperties, useRef } from "react"
import { useConfiguration } from "./hooks/useConfiguration";

const componentStyle: CSSProperties = {
    fontSize: "1.2em"
}
const labelStyle: CSSProperties = {
    marginTop: '20px'
}
const textAreaStyle: CSSProperties = {
    width: '100%',
    border: '1px solid',
    marginBottom: '20px',
    padding: '2px'
}
const buttonStyle: CSSProperties = {
    border: '1px solid',
    padding: '5px 10px',
    cursor: 'pointer'
}
export const ConfigurationPane = () => {

    const { config, update } = useConfiguration();

    const onSave = () => {
        window.location.reload();
    }
    return (
        <div style={componentStyle}>
            <div style={labelStyle}>Was sollte ich über dich wissen, um meine Antworten passender zu gestalten?</div>
            <textarea value={config.personalizedInformation} onChange={(evt => update({...config, personalizedInformation: evt.target.value}))} style={textAreaStyle}  rows={7}>

            </textarea>
            <div style={labelStyle}>Wie soll ich mich dir gegenüber verhalten?</div>
            <textarea value={config.personalizedResponseBehavior} onChange={(evt => update({...config, personalizedResponseBehavior: evt.target.value}))} style={textAreaStyle} rows={7}>

            </textarea>
            <input type="button" style={buttonStyle} value="Speichern" onClick={onSave}></input>
        </div>
    )
} 